/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
	/** A high-precision decimal scalar for monetary values. */
	Decimal: string;
}

/** Margin Trade Offer Accept */
export interface AcceptMarginOfferRequest {
	offerId: Scalars["ID"];
}

export interface AcceptMarginOfferResponse {
	__typename?: "AcceptMarginOfferResponse";
	assetId: Scalars["ID"];
	fiatWalletTransaction?: Maybe<FiatWalletTransaction>;
	isTaxable?: Maybe<Scalars["Boolean"]>;
	leverageDirection: LeverageDirection;
	newOfferAssetAmount: Scalars["Decimal"];
	newOfferPositionChangeInFiat: Scalars["Decimal"];
	newOfferPositionLeverage: Scalars["Int"];
	newOfferPositionWeightedLeverage: Scalars["Decimal"];
	offerStatus: MarginOfferStatus;
	positionStatus: PositionStatus;
	serverTime: DateTime;
	taxWithHeld?: Maybe<Tax>;
	tradeFiatId: Scalars["ID"];
}

export interface AcceptOfferInProgress {
	__typename?: "AcceptOfferInProgress";
	amountAsset: CurrencyAmount;
	amountFiat: CurrencyAmount;
	assetId: Scalars["ID"];
	assetWallet?: Maybe<Wallet>;
	feePercentage: CurrencyAmount;
	fiatId: Scalars["ID"];
	fiatWallet?: Maybe<Wallet>;
	price: CurrencyAmount;
	type: TradeType;
}

export interface AcceptOfferInProgressResponse {
	__typename?: "AcceptOfferInProgressResponse";
	acceptOfferInProgress: AcceptOfferInProgress;
}

/** acceptOffer */
export interface AcceptOfferRequest {
	assetWalletId?: InputMaybe<Scalars["ID"]>;
	fiatWalletId?: InputMaybe<Scalars["ID"]>;
	offerId: Scalars["ID"];
}

/** Mutations / Queries / Subscriptions */
export type AcceptOfferResponse = AcceptOfferInProgressResponse | AcceptOfferSuccessResponse;

export interface AcceptOfferSuccessResponse {
	__typename?: "AcceptOfferSuccessResponse";
	trade: Trade;
}

/** acceptOffersInProgress */
export interface AcceptOffersInProgressResponse {
	__typename?: "AcceptOffersInProgressResponse";
	acceptOffersInProgress: Array<AcceptOfferInProgress>;
}

/** Domain Types */
export enum AmountDefinedFor {
	Assets = "ASSETS",
	Fiat = "FIAT"
}

export interface AmountWithFiat {
	__typename?: "AmountWithFiat";
	amount: CurrencyAmount;
	fiatId: Scalars["ID"];
}

export interface AppropriatenessTest {
	__typename?: "AppropriatenessTest";
	label?: Maybe<Scalars["String"]>;
	required: Scalars["Boolean"];
	warning: Scalars["Boolean"];
}

export interface AssetFiatRange {
	__typename?: "AssetFiatRange";
	asset: Scalars["Decimal"];
	fiat: Scalars["Decimal"];
}

export interface AssetTradingOperationsInProgress {
	__typename?: "AssetTradingOperationsInProgress";
	assetId: Scalars["ID"];
	operations?: Maybe<Array<TradingOperationInProgress>>;
}

export interface BciClaim extends TradeWithId {
	__typename?: "BciClaim";
	assetId: Scalars["ID"];
	createdAt: DateTime;
	fiatId: Scalars["ID"];
	tradeId: Scalars["ID"];
}

export interface BciClaimInProgress extends TradeWithId {
	__typename?: "BciClaimInProgress";
	assetId: Scalars["ID"];
	fiatId: Scalars["ID"];
	tradeId: Scalars["ID"];
}

export interface BciClaimInProgressResponse {
	__typename?: "BciClaimInProgressResponse";
	tradeInProgress: BciClaimInProgress;
}

export interface BciClaimRequest {
	assetId: Scalars["ID"];
	fiatId: Scalars["ID"];
}

export type BciClaimResponse = BciClaimInProgressResponse | BciClaimSuccessResponse;

export interface BciClaimSuccessResponse {
	__typename?: "BciClaimSuccessResponse";
	trade: BciClaim;
}

export interface BciTrade extends TradeWithId {
	__typename?: "BciTrade";
	action: BciTradeAction;
	amount: CurrencyAmount;
	assetId: Scalars["ID"];
	createdAt: DateTime;
	fiatId: Scalars["ID"];
	isTaxable: Scalars["Boolean"];
	taxWithheld?: Maybe<Tax>;
	tradeId: Scalars["ID"];
	wallet: Wallet;
}

export enum BciTradeAction {
	Buy = "BUY",
	Sell = "SELL"
}

export interface BciTradeInProgress extends TradeWithId {
	__typename?: "BciTradeInProgress";
	action: BciTradeAction;
	assetId: Scalars["ID"];
	fiatId: Scalars["ID"];
	tradeId: Scalars["ID"];
}

export interface BciTradeInProgressResponse {
	__typename?: "BciTradeInProgressResponse";
	tradeInProgress: BciTradeInProgress;
}

/** BciTrade */
export interface BciTradeRequest {
	amount: CurrencyAmountInput;
	assetId: Scalars["ID"];
	fiatId: Scalars["ID"];
}

export type BciTradeResponse = BciTradeInProgressResponse | BciTradeSuccessResponse;

export interface BciTradeSellAllRequest {
	assetId: Scalars["ID"];
	fiatId: Scalars["ID"];
}

export interface BciTradeSuccessResponse {
	__typename?: "BciTradeSuccessResponse";
	trade: BciTrade;
}

export interface BciTradesInProgressItem extends TradeWithId {
	__typename?: "BciTradesInProgressItem";
	tradeId: Scalars["ID"];
}

export interface BciTradesInProgressResponse {
	__typename?: "BciTradesInProgressResponse";
	trades: Array<BciTradesInProgressItem>;
}

export interface Bonus {
	__typename?: "Bonus";
	amount: Scalars["String"];
	type: BonusType;
	unitId: Scalars["ID"];
}

export enum BonusType {
	Asset = "ASSET",
	Fiat = "FIAT"
}

export interface CountOrderResponse {
	__typename?: "CountOrderResponse";
	buy: Scalars["Int"];
	sell: Scalars["Int"];
}

/** CountOrders */
export interface CountOrdersFilter {
	assetId?: InputMaybe<Scalars["ID"]>;
}

export interface CountOrdersResponse {
	__typename?: "CountOrdersResponse";
	closed: CountOrderResponse;
	done: CountOrderResponse;
	maxOpenOrders: Scalars["Int"];
	opened: CountOrderResponse;
	total: CountOrderResponse;
}

/** createBciTax */
export interface CreateBciTaxRequest {
	amount: CurrencyAmountInput;
	assetId: Scalars["ID"];
	fiatId: Scalars["ID"];
	type: BciTradeAction;
}

export interface CreateBciTaxResponse {
	__typename?: "CreateBciTaxResponse";
	code: Scalars["String"];
	isTaxable: Scalars["Boolean"];
	taxWithheld?: Maybe<Tax>;
}

export interface CreateLimitMarginOrderPendingResponse {
	__typename?: "CreateLimitMarginOrderPendingResponse";
	amountAsset: Scalars["Decimal"];
}

export interface CreateLimitMarginOrderRequest {
	amount: CurrencyAmountInput;
	assetId: Scalars["ID"];
	exitOrderType: ExitMarginOrderType;
	leverageDirection: LeverageDirection;
	price: CurrencyAmountInput;
	priceFiatUnit: UnitDefinition;
	tradeType: TradeType;
	tradeUnit: UnitDefinition;
}

/** Margin Order Create */
export type CreateLimitMarginOrderResponse =
	| CreateLimitMarginOrderPendingResponse
	| CreateLimitMarginOrderSuccessResponse;

export interface CreateLimitMarginOrderSuccessResponse {
	__typename?: "CreateLimitMarginOrderSuccessResponse";
	amountAsset: Scalars["Decimal"];
	amountFiat: Scalars["Decimal"];
	createdAt: DateTime;
	orderId: Scalars["ID"];
	tradeFiatId: Scalars["ID"];
}

/** Margin Trade Offer Create */
export interface CreateMarginOfferRequest {
	amount: CurrencyAmountInput;
	amountDefinition: UnitDefinition;
	assetId: Scalars["ID"];
	leverage: Scalars["Int"];
	leverageDirection: LeverageDirection;
	tradeType: TradeType;
	tradeUnit: UnitDefinition;
}

export interface CreateMarginOfferResponse {
	__typename?: "CreateMarginOfferResponse";
	amountAsset: Scalars["Decimal"];
	amountInPairUnit: Scalars["Decimal"];
	amountInTradeUnit: Scalars["Decimal"];
	dailyFee: Scalars["Decimal"];
	expiresAt: DateTime;
	fee?: Maybe<Fee>;
	isFeeTransparent: Scalars["Boolean"];
	/** @deprecated Use positionChange { ... on MarginPositionDecrease { decreasedPosition { isRemainingPositionDust } } } instead */
	isRemainingPositionDust: Scalars["Boolean"];
	isTaxable: Scalars["Boolean"];
	offerId: Scalars["ID"];
	pairUnit: UnitDefinitionResponse;
	positionChange?: Maybe<CreateMarginPositionChangeResponse>;
	positionStatus: PositionStatus;
	price: Scalars["Decimal"];
	serverTime: DateTime;
	tax?: Maybe<Tax>;
	totalPosition: Position;
	tradeFiatId: Scalars["ID"];
	tradeUnit: UnitDefinitionResponse;
	underlyingAssetId: Scalars["ID"];
	userJourney?: Maybe<Scalars["String"]>;
}

export type CreateMarginPositionChangeResponse = MarginPositionDecrease | MarginPositionIncrease;

export interface CreateMultiSwapOffer {
	sourceAssetAmount: CurrencyAmountInput;
	sourceAssetId: Scalars["ID"];
}

/** createOffer */
export interface CreateOfferRequest {
	amount: CurrencyAmountInput;
	amountDefinedFor: AmountDefinedFor;
	assetId: Scalars["ID"];
	fiatId: Scalars["ID"];
	type: TradeType;
	visionBonus?: InputMaybe<Scalars["Boolean"]>;
}

export interface CreateOfferResponse {
	__typename?: "CreateOfferResponse";
	code: Scalars["String"];
	offer?: Maybe<Offer>;
}

/** createOtcTrade */
export interface CreateOtcTradeRequest {
	adjustStock?: InputMaybe<Scalars["Boolean"]>;
	amount: CurrencyAmountInput;
	amountDefinedFor: AmountDefinedFor;
	assetId: Scalars["ID"];
	assetWalletId?: InputMaybe<Scalars["ID"]>;
	authorUserId: Scalars["ID"];
	fiatId: Scalars["ID"];
	fiatWalletId?: InputMaybe<Scalars["ID"]>;
	price: CurrencyAmountInput;
	priceInclFee: CurrencyAmountInput;
	taskId?: InputMaybe<Scalars["String"]>;
	type: TradeType;
}

export interface CreateOtcTradeResponse {
	__typename?: "CreateOtcTradeResponse";
	code: Scalars["String"];
	offerId?: Maybe<Scalars["String"]>;
}

/** createTrade */
export interface CreateTradeRequest {
	amountBase: CurrencyAmountInput;
	amountQuote: CurrencyAmountInput;
	baseAssetId: Scalars["ID"];
	fee: CurrencyAmountInput;
	feePercentage: CurrencyAmountInput;
	price: CurrencyAmountInput;
	priceInclFee: CurrencyAmountInput;
	quoteAssetId: Scalars["ID"];
	type: TradeType;
}

export interface CreateTradeResponse {
	__typename?: "CreateTradeResponse";
	tradeId: Scalars["ID"];
}

/** Value Types */
export interface CurrencyAmount {
	__typename?: "CurrencyAmount";
	value: Scalars["String"];
}

export interface CurrencyAmountInput {
	value: Scalars["String"];
}

export interface DateTime {
	__typename?: "DateTime";
	iso8601: Scalars["String"];
	unixTimestamp: Scalars["Int"];
}

export interface DecreasedLimitOrderPosition {
	__typename?: "DecreasedLimitOrderPosition";
	destinationWalletSymbol?: Maybe<Scalars["String"]>;
	exitOrderType: ExitMarginOrderType;
	fee?: Maybe<Fee>;
	isFeeTransparent: Scalars["Boolean"];
	remainingFundsInUnderlyingAsset: Scalars["Decimal"];
	repayingFundsInUnderlyingAsset: Scalars["Decimal"];
	serverTime: DateTime;
	tradeFiat: EstimateLimitMarginOrderAmount;
	tradeUnit: UnitDefinitionResponse;
	underlyingAsset: EstimateLimitMarginOrderAmount;
	userJourney?: Maybe<Scalars["String"]>;
}

export interface DecreasedPosition {
	__typename?: "DecreasedPosition";
	isRemainingPositionDust: Scalars["Boolean"];
	receivedFunds: Scalars["Decimal"];
	repayingFundsInFiat: Scalars["Decimal"];
	repayingFundsInUnderlyingAsset: Scalars["Decimal"];
}

export interface Eligibility {
	__typename?: "Eligibility";
	isAddressVerified: Scalars["Boolean"];
	isSanInformationSet: Scalars["Boolean"];
	realStocksConsent: RealStocksConsent;
	residencyDeclarations: ResidencyDeclaration;
	tinDeclaration: TinDeclaration;
}

export interface Error {
	__typename?: "Error";
	httpCode: Scalars["String"];
	key: Scalars["String"];
	localizedDisplayMessage: Scalars["String"];
}

export interface ErrorItem {
	__typename?: "ErrorItem";
	assetId: Scalars["ID"];
	error: MultiSwapError;
}

export interface EstimateIndexPricesFiat {
	__typename?: "EstimateIndexPricesFiat";
	max: Scalars["Decimal"];
	min: Scalars["Decimal"];
}

/** Index Prices Estimate */
export interface EstimateIndexPricesInput {
	fiatId: Scalars["ID"];
	indexId: Scalars["ID"];
	type: TradeType;
}

export interface EstimateIndexPricesResponse {
	__typename?: "EstimateIndexPricesResponse";
	fiat: EstimateIndexPricesFiat;
}

/** Margin Order Estimate */
export interface EstimateLimitMarginOrderAmount {
	__typename?: "EstimateLimitMarginOrderAmount";
	amount: Scalars["Decimal"];
	id: Scalars["ID"];
}

export interface EstimateLimitMarginOrderRequest {
	amount: CurrencyAmountInput;
	assetId: Scalars["ID"];
	exitOrderType: ExitMarginOrderType;
	leverageDirection: LeverageDirection;
	price: CurrencyAmountInput;
	priceFiatUnit: UnitDefinition;
	tradeType: TradeType;
	tradeUnit: UnitDefinition;
}

export type EstimateLimitMarginOrderResponse = DecreasedLimitOrderPosition | IncreasedLimitOrderPosition;

/** Margin Trade Estimate */
export interface EstimateMarginOfferRequest {
	amount: CurrencyAmountInput;
	amountDefinition: UnitDefinition;
	assetId: Scalars["ID"];
	leverage: Scalars["Float"];
	leverageDirection: LeverageDirection;
	tradeType: TradeType;
	tradeUnit: UnitDefinition;
}

/** EstimateOrder */
export interface EstimateOrderResponse {
	__typename?: "EstimateOrderResponse";
	fee?: Maybe<FeeAmount>;
	feePercentage?: Maybe<FeePercentage>;
	isFeeTransparent: Scalars["Boolean"];
	/** @deprecated Field no longer supported */
	itb?: Maybe<CurrencyAmount>;
	tax?: Maybe<OrderTax>;
	userJourney: Scalars["String"];
	value: CurrencyAmount;
	vsnFeeTokenCollection: EstimateOrderVsnCollection;
}

export interface EstimateOrderVsnCollection {
	__typename?: "EstimateOrderVsnCollection";
	eligibleForVsn: Scalars["Boolean"];
	enabled: Scalars["Boolean"];
	feeDiscount: Scalars["String"];
	feeDiscountBefore?: Maybe<Scalars["String"]>;
	globalOptIn?: Maybe<Scalars["Boolean"]>;
}

/** Prices Estimate */
export interface EstimatePricesInput {
	assetId: Scalars["ID"];
	assetWalletId?: InputMaybe<Scalars["ID"]>;
	fiatId: Scalars["ID"];
	type: TradeType;
}

/** Swap Prices Estimate */
export interface EstimateSwapPricesInput {
	fiatId?: InputMaybe<Scalars["ID"]>;
	sourceAssetId: Scalars["ID"];
	sourceWalletId: Scalars["ID"];
	targetAssetId: Scalars["ID"];
}

export interface EstimateSwapPricesResponse {
	__typename?: "EstimateSwapPricesResponse";
	appropriatenessTest: AppropriatenessTest;
	source: EstimateSwapPricesSource;
	target: EstimateSwapPricesTarget;
	userJourney: Scalars["String"];
}

export interface EstimateSwapPricesSource {
	__typename?: "EstimateSwapPricesSource";
	max: EstimateSwapPricesSourceRange;
	min: EstimateSwapPricesSourceRange;
	toTargetRatio: Scalars["Decimal"];
}

export interface EstimateSwapPricesSourceRange {
	__typename?: "EstimateSwapPricesSourceRange";
	asset: Scalars["Decimal"];
	fiat: Scalars["Decimal"];
}

export interface EstimateSwapPricesTarget {
	__typename?: "EstimateSwapPricesTarget";
	forMaxSource: Scalars["Decimal"];
	forMaxSourceFiat: Scalars["Decimal"];
	forMinSource: Scalars["Decimal"];
	forMinSourceFiat: Scalars["Decimal"];
	toSourceRatio: Scalars["Decimal"];
}

export interface ExAnteEstimateReport {
	__typename?: "ExAnteEstimateReport";
	costsAndCharges: ExAnteReportCostsAndCharges;
	cumulativeCosts: Array<ExAnteReportCumulativeCosts>;
	impactOnPerformance: ExAnteReportImpactOnPerformance;
	instrumentIsin: Scalars["String"];
	offer: ExAnteEstimateReportOffer;
}

export interface ExAnteEstimateReportOffer {
	__typename?: "ExAnteEstimateReportOffer";
	amountAsset: CurrencyAmount;
	amountFiat: CurrencyAmount;
	fee: CurrencyAmount;
	fxRate: ExAnteReportFxRate;
}

export interface ExAnteReport {
	__typename?: "ExAnteReport";
	costsAndCharges: ExAnteReportCostsAndCharges;
	cumulativeCosts: Array<ExAnteReportCumulativeCosts>;
	impactOnPerformance: ExAnteReportImpactOnPerformance;
	instrumentIsin: Scalars["String"];
	offer: ExAnteReportOffer;
}

export interface ExAnteReportCostBreakdown {
	__typename?: "ExAnteReportCostBreakdown";
	amount: CurrencyAmount;
	investmentPercent: Scalars["Decimal"];
	type: Scalars["String"];
}

export interface ExAnteReportCostsAndCharges {
	__typename?: "ExAnteReportCostsAndCharges";
	breakdown: Array<ExAnteReportCostBreakdown>;
	totalCosts: ExAnteReportTotalCosts;
}

export interface ExAnteReportCumulativeCosts {
	__typename?: "ExAnteReportCumulativeCosts";
	estimatedCosts: CurrencyAmount;
	holdingPeriod: Scalars["String"];
	returnsPercentPerAnnum: Scalars["Decimal"];
}

/** Ex Ante Report */
export interface ExAnteReportFxRate {
	__typename?: "ExAnteReportFxRate";
	fromFiatId: Scalars["ID"];
	rate: Scalars["Decimal"];
	toFiatId: Scalars["ID"];
}

export interface ExAnteReportImpactOnPerformance {
	__typename?: "ExAnteReportImpactOnPerformance";
	annualReturnPercent: Scalars["Decimal"];
	estimatedReductionInReturnPercent: Scalars["Decimal"];
	netInvestmentAfterCosts: CurrencyAmount;
	reducedAnnualReturnPercent: Scalars["Decimal"];
}

export interface ExAnteReportOffer {
	__typename?: "ExAnteReportOffer";
	amountAsset: CurrencyAmount;
	amountFiat: CurrencyAmount;
	fee: CurrencyAmount;
	fxRate: ExAnteReportFxRate;
	id: Scalars["ID"];
}

export interface ExAnteReportTotalCosts {
	__typename?: "ExAnteReportTotalCosts";
	amount: CurrencyAmount;
	investmentPercent: Scalars["Decimal"];
}

export enum ExitMarginOrderType {
	StopLoss = "STOP_LOSS",
	TakeProfit = "TAKE_PROFIT"
}

/**
 * FailureResponse. Contains both an error object as well as a
 * meta object which will only be delivered if there is actionable information
 * to be communicated.
 *
 * In an Error-Case (such as a 500 Internal Server Error) you will receive the
 * same structure under the "bitpanda" key in the extensions section of the
 * Error response. See https://www.apollographql.com/docs/apollo-server/data/errors/.
 *
 * interface ErrorResponse {
 * error: Error!
 * meta: Any
 * }
 *
 * Note: The above is not an actual GraphQL type but serves to illustrate the format of Error responses.
 */
export interface FailureResponse {
	error: Error;
}

export interface Fee {
	__typename?: "Fee";
	asset: FeeAmount;
	fiat: FeeAmount;
	fiatRate?: Maybe<FeeAmount>;
	net: FeeAmount;
	percentage: FeePercentage;
	priceWithoutFee: FeeAmount;
	provider?: Maybe<Scalars["String"]>;
}

export interface FeeAmount {
	__typename?: "FeeAmount";
	value: Scalars["String"];
}

export interface FeePercentage {
	__typename?: "FeePercentage";
	value: Scalars["String"];
}

export enum FetchOrderStatus {
	Closed = "CLOSED",
	Done = "DONE",
	Open = "OPEN"
}

/** FetchOrders */
export interface FetchOrdersFilter {
	assetId?: InputMaybe<Scalars["ID"]>;
	status?: InputMaybe<FetchOrderStatus>;
	type?: InputMaybe<OrderType>;
}

export interface FetchOrdersResponse {
	__typename?: "FetchOrdersResponse";
	orders: Array<Maybe<Order>>;
	pageInfo?: Maybe<PaginationResponse>;
}

export interface FiatWalletTransaction {
	__typename?: "FiatWalletTransaction";
	id: Scalars["ID"];
}

export interface HealthFailure extends FailureResponse {
	__typename?: "HealthFailure";
	error: Error;
	meta?: Maybe<HealthFailureMeta>;
}

export interface HealthFailureMeta {
	__typename?: "HealthFailureMeta";
	aMetaField?: Maybe<Scalars["String"]>;
}

/** health */
export type HealthResponse = HealthFailure | HealthSuccess;

export interface HealthSuccess {
	__typename?: "HealthSuccess";
	code: Scalars["String"];
}

export interface HealthThreshold {
	__typename?: "HealthThreshold";
	high: Scalars["Decimal"];
	low: Scalars["Decimal"];
}

export interface IncreasedLimitOrderPosition {
	__typename?: "IncreasedLimitOrderPosition";
	id: Scalars["ID"];
}

export interface IncreasedPosition {
	__typename?: "IncreasedPosition";
	borrowedFundsInUnderlyingAsset: Scalars["Decimal"];
	leverage: Scalars["Decimal"];
	totalPositionInAsset: Scalars["Decimal"];
	totalPositionInFiat: Scalars["Decimal"];
}

export interface Leverage {
	__typename?: "Leverage";
	highlighted: Scalars["Boolean"];
	level: Scalars["Float"];
}

export enum LeverageDirection {
	Long = "LONG",
	Short = "SHORT"
}

/** Limit Margin Order Balance Query */
export interface LimitMarginOrderBalanceResponse {
	__typename?: "LimitMarginOrderBalanceResponse";
	stopLossAvailableBalance: Scalars["Decimal"];
	takeProfitAvailableBalance: Scalars["Decimal"];
}

export interface MarginEstimateAppropriateness {
	__typename?: "MarginEstimateAppropriateness";
	coolOffEnd?: Maybe<DateTime>;
	label: Scalars["String"];
	status: Scalars["Boolean"];
}

export interface MarginEstimateOfferResponse {
	__typename?: "MarginEstimateOfferResponse";
	defaultLeverage: Scalars["Float"];
	leverageEstimates: Array<MarginLeverageEstimate>;
	leverages: Array<Leverage>;
	marginAppropriateness: MarginEstimateAppropriateness;
	positionBalance: PositionBalance;
	/** @deprecated Use leverageEstimates { positionChange } instead */
	positionChange?: Maybe<CreateMarginPositionChangeResponse>;
	positionStatus: PositionStatus;
	/** @deprecated Use leverages instead */
	possibleLeverages: Array<Scalars["Int"]>;
	serverTime: DateTime;
	/** @deprecated Use leverageEstimates { totalPosition } instead */
	totalPosition: Position;
	tradeFiatId: Scalars["ID"];
	underlyingAssetId: Scalars["ID"];
}

export enum MarginHealthIndicator {
	High = "HIGH",
	Low = "LOW",
	Medium = "MEDIUM"
}

export interface MarginLeverageEstimate {
	__typename?: "MarginLeverageEstimate";
	isDepositAllowed: Scalars["Boolean"];
	leverage: Scalars["Float"];
	positionChange?: Maybe<CreateMarginPositionChangeResponse>;
	totalPosition: Position;
}

export interface MarginLimitOrder {
	__typename?: "MarginLimitOrder";
	amount: Scalars["Decimal"];
	assetId: Scalars["ID"];
	createdAt?: Maybe<DateTime>;
	exitOrderType: ExitMarginOrderType;
	id: Scalars["ID"];
	status: OrderStatus;
	targetPrice: Scalars["Decimal"];
	tradeType: TradeType;
}

export interface MarginLimitOrderInProgressResponse {
	__typename?: "MarginLimitOrderInProgressResponse";
	_?: Maybe<Scalars["Boolean"]>;
}

export interface MarginLimitOrderSuccessResponse {
	__typename?: "MarginLimitOrderSuccessResponse";
	order: MarginLimitOrder;
}

export enum MarginOfferStatus {
	Pending = "PENDING",
	Success = "SUCCESS"
}

export interface MarginPositionDecrease {
	__typename?: "MarginPositionDecrease";
	decreasedPosition?: Maybe<DecreasedPosition>;
}

export interface MarginPositionIncrease {
	__typename?: "MarginPositionIncrease";
	addedPosition?: Maybe<IncreasedPosition>;
}

export interface MigrateToWeb3Response {
	__typename?: "MigrateToWeb3Response";
	amount?: Maybe<CurrencyAmount>;
	code: Scalars["Int"];
}

export interface MultiSwap {
	__typename?: "MultiSwap";
	errorItems?: Maybe<Array<Maybe<ErrorItem>>>;
	multiSwapItems: Array<Maybe<MultiSwapItem>>;
	swapId: Scalars["ID"];
	totalFiatAssetAmount: CurrencyAmount;
	totalTargetAssetAmount: CurrencyAmount;
}

/** multiSwapAccept */
export interface MultiSwapAcceptRequest {
	multiSwapAccept?: InputMaybe<Array<InputMaybe<SwapAccept>>>;
	swapOfferId: Scalars["ID"];
}

export type MultiSwapAcceptResponse = MultiSwapSuccessResponse | SwapInProgressResponse;

export interface MultiSwapError {
	__typename?: "MultiSwapError";
	errorCode?: Maybe<Scalars["String"]>;
	statusCode?: Maybe<Scalars["Int"]>;
	translationKey?: Maybe<Scalars["String"]>;
}

export interface MultiSwapItem {
	__typename?: "MultiSwapItem";
	sourceTrade: MultiSwapTrade;
	targetTrade: MultiSwapTrade;
}

export interface MultiSwapOffer {
	__typename?: "MultiSwapOffer";
	errorItems?: Maybe<Array<Maybe<ErrorItem>>>;
	expiresAt: DateTime;
	fiatAssetId: Scalars["ID"];
	swapOfferId: Scalars["ID"];
	swapOffers: Array<Maybe<SwapOffer>>;
	targetAssetId?: Maybe<Scalars["ID"]>;
	totalFiatAssetAmount: CurrencyAmount;
	totalTargetAssetAmount: CurrencyAmount;
}

/** multiSwapOffer */
export interface MultiSwapOfferRequest {
	fiatId: Scalars["ID"];
	multiSwapOffer: Array<InputMaybe<CreateMultiSwapOffer>>;
}

export interface MultiSwapOfferResponse {
	__typename?: "MultiSwapOfferResponse";
	code: Scalars["String"];
	multiSwapOffer?: Maybe<MultiSwapOffer>;
}

export interface MultiSwapSuccessResponse {
	__typename?: "MultiSwapSuccessResponse";
	multiSwap: MultiSwap;
}

export interface MultiSwapTrade extends TradeWithId {
	__typename?: "MultiSwapTrade";
	amountAsset: CurrencyAmount;
	amountFiat: CurrencyAmount;
	assetId: Scalars["ID"];
	executionTime: DateTime;
	feePercentage: CurrencyAmount;
	fiatWallet?: Maybe<Wallet>;
	fiatWalletTransaction?: Maybe<FiatWalletTransaction>;
	tradeId: Scalars["ID"];
	wallet: Wallet;
}

export interface Mutation {
	__typename?: "Mutation";
	acceptMarginOffer: AcceptMarginOfferResponse;
	acceptOffer: AcceptOfferResponse;
	buyBci: BciTradeResponse;
	claimBci: BciClaimResponse;
	createBciTax: CreateBciTaxResponse;
	createLimitMarginOrder: CreateLimitMarginOrderResponse;
	createMarginOffer: CreateMarginOfferResponse;
	createOffer: CreateOfferResponse;
	createOrder: OrderResponse;
	createOtcTrade: CreateOtcTradeResponse;
	createTrade: CreateTradeResponse;
	estimateMarginOffer: MarginEstimateOfferResponse;
	migrateToWeb3: MigrateToWeb3Response;
	multiSwapAccept: MultiSwapAcceptResponse;
	multiSwapOffer: MultiSwapOfferResponse;
	sellAllBci: BciTradeResponse;
	sellBci: BciTradeResponse;
	signUpForWeb3Migration: Web3MigrationSignUpResponse;
	swap: SwapResponse;
	swapOfferAccept: SwapOfferAcceptResponse;
	swapOfferCreate: SwapOfferCreateResponse;
	updateLimitMarginOrder?: Maybe<UpdateLimitMarginOrderResponse>;
	updateOrder: OrderResponse;
	userSettingsUpdate: UserSettingsUpdateResponse;
}

export interface MutationAcceptMarginOfferArgs {
	request: AcceptMarginOfferRequest;
}

export interface MutationAcceptOfferArgs {
	request: AcceptOfferRequest;
}

export interface MutationBuyBciArgs {
	request: BciTradeRequest;
}

export interface MutationClaimBciArgs {
	request: BciClaimRequest;
}

export interface MutationCreateBciTaxArgs {
	request: CreateBciTaxRequest;
}

export interface MutationCreateLimitMarginOrderArgs {
	request: CreateLimitMarginOrderRequest;
}

export interface MutationCreateMarginOfferArgs {
	request: CreateMarginOfferRequest;
}

export interface MutationCreateOfferArgs {
	request: CreateOfferRequest;
}

export interface MutationCreateOrderArgs {
	request: CreateOrderRequest;
}

export interface MutationCreateOtcTradeArgs {
	request: CreateOtcTradeRequest;
}

export interface MutationCreateTradeArgs {
	request: CreateTradeRequest;
}

export interface MutationEstimateMarginOfferArgs {
	request: EstimateMarginOfferRequest;
}

export interface MutationMultiSwapAcceptArgs {
	request: MultiSwapAcceptRequest;
}

export interface MutationMultiSwapOfferArgs {
	request: MultiSwapOfferRequest;
}

export interface MutationSellAllBciArgs {
	request: BciTradeSellAllRequest;
}

export interface MutationSellBciArgs {
	request: BciTradeRequest;
}

export interface MutationSwapArgs {
	request: SwapRequest;
}

export interface MutationSwapOfferAcceptArgs {
	request: SwapOfferAcceptRequest;
}

export interface MutationSwapOfferCreateArgs {
	request: SwapOfferCreateRequest;
}

export interface MutationUpdateLimitMarginOrderArgs {
	request: UpdateLimitMarginOrderRequest;
}

export interface MutationUpdateOrderArgs {
	request: UpdateOrderRequest;
}

export interface MutationUserSettingsUpdateArgs {
	request: UserSettingsUpdateRequest;
}

export interface Offer {
	__typename?: "Offer";
	amountAsset: CurrencyAmount;
	amountFiat: CurrencyAmount;
	currentBorrow?: Maybe<CurrencyAmount>;
	effectiveLeverage?: Maybe<CurrencyAmount>;
	expiresAt: DateTime;
	fee?: Maybe<Fee>;
	futureBorrow?: Maybe<CurrencyAmount>;
	isFeeTransparent: Scalars["Boolean"];
	isTaxable: Scalars["Boolean"];
	offerId: Scalars["ID"];
	price: CurrencyAmount;
	serverTime: DateTime;
	tax?: Maybe<Tax>;
	type: TradeType;
	userJourney: Scalars["String"];
	vsnFeeTokenCollection?: Maybe<VsnFeeTokenCollection>;
	/** Can be set on Security trades such as Stocks and ETFs */
	warnings: Array<OfferWarning>;
}

export interface OfferWarning {
	__typename?: "OfferWarning";
	link: Scalars["String"];
	link_message: Scalars["String"];
	message: Scalars["String"];
}

export enum OperationType {
	Otc = "OTC",
	SwapDust = "SWAP_DUST"
}

export interface Order {
	__typename?: "Order";
	amount: CurrencyAmount;
	assetId?: Maybe<Scalars["ID"]>;
	createdAt: DateTime;
	executedAt?: Maybe<DateTime>;
	failedAt?: Maybe<DateTime>;
	failedReason?: Maybe<Scalars["String"]>;
	fiatId: Scalars["ID"];
	orderId: Scalars["ID"];
	price: CurrencyAmount;
	status: OrderStatus;
	type: OrderType;
}

export enum OrderField {
	CreatedAt = "CREATED_AT",
	ExecutedAt = "EXECUTED_AT",
	FailedAt = "FAILED_AT"
}

export interface OrderInProgressResponse {
	__typename?: "OrderInProgressResponse";
	_?: Maybe<Scalars["Boolean"]>;
}

export type OrderResponse = OrderInProgressResponse | OrderSuccessResponse;

export enum OrderStatus {
	Cancelled = "CANCELLED",
	Done = "DONE",
	Failed = "FAILED",
	InProgress = "IN_PROGRESS",
	Pending = "PENDING"
}

export interface OrderSuccessResponse {
	__typename?: "OrderSuccessResponse";
	order: Order;
}

export interface OrderTax {
	__typename?: "OrderTax";
	taxResidency?: Maybe<Scalars["String"]>;
}

export enum OrderType {
	Buy = "BUY",
	Sell = "SELL"
}

export interface PaginationInput {
	page?: InputMaybe<Scalars["Int"]>;
	pageSize?: InputMaybe<Scalars["Int"]>;
}

export interface PaginationResponse {
	__typename?: "PaginationResponse";
	currentPage: Scalars["Int"];
	totalItems: Scalars["Int"];
	totalPages: Scalars["Int"];
}

export interface Position {
	__typename?: "Position";
	assetId: Scalars["ID"];
	availableToBorrowInUnderlyingAsset?: Maybe<Scalars["Decimal"]>;
	borrowedFundsInFiat: Scalars["Decimal"];
	borrowedFundsInUnderlyingAsset: Scalars["Decimal"];
	healthIndicator: MarginHealthIndicator;
	healthThreshold: HealthThreshold;
	leverage: Scalars["Decimal"];
	leverageDirection: LeverageDirection;
	liquidationPriceInFiat: Scalars["Decimal"];
	liquidationThresholdPercentage: Scalars["Decimal"];
	marginLevel: Scalars["Decimal"];
	marginMaximum: Scalars["Decimal"];
	marginMinimum: Scalars["Decimal"];
	pricePerUnitInFiat: Scalars["Decimal"];
	totalPositionInAsset: Scalars["Decimal"];
	totalPositionInFiat: Scalars["Decimal"];
}

export interface PositionBalance {
	__typename?: "PositionBalance";
	availableBalanceInAsset: Scalars["Decimal"];
	availableBalanceInFiat: Scalars["Decimal"];
}

export enum PositionStatus {
	Close = "CLOSE",
	Decrease = "DECREASE",
	Increase = "INCREASE",
	Open = "OPEN"
}

export interface PriceEstimationResponse {
	__typename?: "PriceEstimationResponse";
	appropriatenessTest: AppropriatenessTest;
	eligibility?: Maybe<Eligibility>;
	max: AssetFiatRange;
	min: AssetFiatRange;
	price: Scalars["Decimal"];
}

export interface Query {
	__typename?: "Query";
	acceptOffersInProgress: AcceptOffersInProgressResponse;
	/** Exactly one of the below IDs must be supplied to avoid ambiguity, otherwise Bad Request will be returned. */
	bciTradesInProgress: BciTradesInProgressResponse;
	countOrders: CountOrdersResponse;
	estimateIndexPrices: EstimateIndexPricesResponse;
	estimateLimitMarginOrder: EstimateLimitMarginOrderResponse;
	estimateOrder: EstimateOrderResponse;
	estimatePrices: PriceEstimationResponse;
	estimateSwapPrices: EstimateSwapPricesResponse;
	estimateWeb3Migration: Web3MigrationEstimation;
	exAnteReport: ExAnteReport;
	exAnteReportEstimate: ExAnteEstimateReport;
	fetchOrder: Order;
	fetchOrders: FetchOrdersResponse;
	health: HealthResponse;
	limitMarginOrderBalance: LimitMarginOrderBalanceResponse;
	swapsInProgress: SwapsInProgressResponse;
	totalOrders: TotalOrdersResult;
	totalSellOrders: TotalSellOrdersResult;
	tradingOperationsInProgress: TradingOperationInProgressResponse;
	tradingSettings: TradingSettingsResponse;
	userSettings: UserSettingsResponse;
	visionBurns: VisionBurnData;
	visionTradingFeeBenefit: VisionTradingFeeBenefitResponse;
	walletBalance: WalletBalanceResponse;
	web3Migration: Web3MigrationStatus;
}

export interface QueryCountOrdersArgs {
	filter?: InputMaybe<CountOrdersFilter>;
}

export interface QueryEstimateIndexPricesArgs {
	input: EstimateIndexPricesInput;
}

export interface QueryEstimateLimitMarginOrderArgs {
	input: EstimateLimitMarginOrderRequest;
}

export interface QueryEstimateOrderArgs {
	amount: CurrencyAmountInput;
	assetId: Scalars["ID"];
	fiatId: Scalars["ID"];
	price: CurrencyAmountInput;
	type?: InputMaybe<OrderType>;
	visionBonus?: InputMaybe<Scalars["Boolean"]>;
}

export interface QueryEstimatePricesArgs {
	input: EstimatePricesInput;
}

export interface QueryEstimateSwapPricesArgs {
	input: EstimateSwapPricesInput;
}

export interface QueryExAnteReportArgs {
	offerId: Scalars["ID"];
}

export interface QueryExAnteReportEstimateArgs {
	assetId: Scalars["ID"];
	fiatAmount: CurrencyAmountInput;
	fiatId: Scalars["ID"];
	operationType?: InputMaybe<Scalars["String"]>;
}

export interface QueryFetchOrderArgs {
	orderId: Scalars["ID"];
}

export interface QueryFetchOrdersArgs {
	filter?: InputMaybe<FetchOrdersFilter>;
	order?: InputMaybe<OrderField>;
	pagination?: InputMaybe<PaginationInput>;
}

export interface QueryLimitMarginOrderBalanceArgs {
	assetId: Scalars["String"];
}

export interface QueryTotalOrdersArgs {
	filter?: InputMaybe<TotalOrdersFilter>;
}

export interface QueryTotalSellOrdersArgs {
	filter: TotalSellOrdersFilter;
}

export interface QueryTradingOperationsInProgressArgs {
	assetId?: InputMaybe<Scalars["ID"]>;
}

export interface QueryVisionBurnsArgs {
	fiatId: Scalars["ID"];
	pagination?: InputMaybe<PaginationInput>;
}

export interface QueryVisionTradingFeeBenefitArgs {
	fiatId: Scalars["ID"];
}

export interface QueryWalletBalanceArgs {
	input: WalletBalanceInput;
}

export interface RealStocksConsent {
	__typename?: "RealStocksConsent";
	isConsentGiven: Scalars["Boolean"];
	userJourney: Scalars["String"];
}

export interface ResidencyDeclaration {
	__typename?: "ResidencyDeclaration";
	countryCode: Scalars["String"];
	isAppropriate?: Maybe<Scalars["Boolean"]>;
	required: Scalars["Boolean"];
}

export interface Swap {
	__typename?: "Swap";
	isTaxable: Scalars["Boolean"];
	sourceTrade: SwapTrade;
	swapId: Scalars["ID"];
	targetTrade: SwapTrade;
	taxWithheld?: Maybe<Tax>;
}

export interface SwapAccept {
	sourceAssetId: Scalars["ID"];
	sourceAssetWalletId?: InputMaybe<Scalars["ID"]>;
}

export enum SwapAmountDefinedFor {
	Source = "SOURCE",
	Target = "TARGET"
}

export interface SwapInProgress {
	__typename?: "SwapInProgress";
	swapId: Scalars["ID"];
}

export interface SwapInProgressResponse {
	__typename?: "SwapInProgressResponse";
	swapInProgress?: Maybe<SwapInProgress>;
}

export interface SwapOffer {
	__typename?: "SwapOffer";
	fiatAssetAmount: CurrencyAmount;
	fiatAssetId: Scalars["ID"];
	sourceAssetAmount: CurrencyAmount;
	sourceAssetId: Scalars["ID"];
	targetAssetAmount: CurrencyAmount;
	targetAssetId: Scalars["ID"];
}

export interface SwapOfferAccept {
	__typename?: "SwapOfferAccept";
	isTaxable: Scalars["Boolean"];
	sourceTrade: SwapOfferAcceptTrade;
	swapOfferId: Scalars["ID"];
	targetTrade: SwapOfferAcceptTrade;
	taxWithheld?: Maybe<Tax>;
}

export interface SwapOfferAcceptRequest {
	sourceAssetWalletId?: InputMaybe<Scalars["ID"]>;
	swapOfferId: Scalars["ID"];
	targetAssetWalletId?: InputMaybe<Scalars["ID"]>;
}

export type SwapOfferAcceptResponse = SwapOfferAcceptSuccessResponse | SwapOfferInProgressResponse;

export interface SwapOfferAcceptSuccessResponse {
	__typename?: "SwapOfferAcceptSuccessResponse";
	swapOffer: SwapOfferAccept;
}

export interface SwapOfferAcceptTrade {
	__typename?: "SwapOfferAcceptTrade";
	amountAsset: CurrencyAmount;
	assetId: Scalars["ID"];
	assetWallet: Wallet;
	executionTime: DateTime;
	feePercentage: FeePercentage;
	fiatWallet: Wallet;
	fiatWalletTransaction: FiatWalletTransaction;
	tradeId: Scalars["ID"];
}

export interface SwapOfferCreate {
	__typename?: "SwapOfferCreate";
	expiresAt: DateTime;
	fee?: Maybe<SwapOfferFee>;
	isFeeTransparent: Scalars["Boolean"];
	isTaxable: Scalars["Boolean"];
	serverTime: DateTime;
	sourceTrade: SwapOfferCreateTrade;
	swapOfferId: Scalars["ID"];
	targetTrade: SwapOfferCreateTrade;
	taxWithheld?: Maybe<Tax>;
	userJourney: Scalars["String"];
	vsnFeeTokenCollection?: Maybe<VsnFeeTokenCollection>;
	warnings: Array<OfferWarning>;
}

/** SwapOffer Create */
export interface SwapOfferCreateRequest {
	amount: CurrencyAmountInput;
	amountDefinedFor: SwapAmountDefinedFor;
	sourceAssetId: Scalars["ID"];
	targetAssetId: Scalars["ID"];
	visionBonus?: InputMaybe<Scalars["Boolean"]>;
}

export interface SwapOfferCreateResponse {
	__typename?: "SwapOfferCreateResponse";
	swapOffer: SwapOfferCreate;
}

export interface SwapOfferCreateTrade {
	__typename?: "SwapOfferCreateTrade";
	amountAsset: CurrencyAmount;
	amountFiat: CurrencyAmount;
	assetId: Scalars["ID"];
	feePercentage: FeePercentage;
	fiatId: Scalars["ID"];
	offerId: Scalars["ID"];
}

export interface SwapOfferFee {
	__typename?: "SwapOfferFee";
	amount: FeeAmount;
	fiatId: Scalars["ID"];
	source: FeeAmount;
	target: FeeAmount;
}

export interface SwapOfferInProgress {
	__typename?: "SwapOfferInProgress";
	swapOfferId: Scalars["ID"];
}

/** SwapOffer Accept */
export interface SwapOfferInProgressResponse {
	__typename?: "SwapOfferInProgressResponse";
	swapOffersInProgress: SwapOfferInProgress;
}

/** Swap */
export interface SwapRequest {
	amount: CurrencyAmountInput;
	amountDefinedFor: SwapAmountDefinedFor;
	sourceAssetId: Scalars["ID"];
	sourceWalletId?: InputMaybe<Scalars["ID"]>;
	targetAssetId: Scalars["ID"];
	targetWalletId?: InputMaybe<Scalars["ID"]>;
}

export type SwapResponse = SwapInProgressResponse | SwapSuccessResponse;

export interface SwapSuccessResponse {
	__typename?: "SwapSuccessResponse";
	swap: Swap;
}

export interface SwapTrade extends TradeWithId {
	__typename?: "SwapTrade";
	amountAsset: CurrencyAmount;
	assetId: Scalars["ID"];
	executionTime: DateTime;
	feePercentage: CurrencyAmount;
	fiatWallet?: Maybe<Wallet>;
	fiatWalletTransaction?: Maybe<FiatWalletTransaction>;
	tradeId: Scalars["ID"];
	wallet: Wallet;
}

export interface SwapsInProgressResponse {
	__typename?: "SwapsInProgressResponse";
	swapsInProgress: Array<SwapInProgress>;
}

export interface Tax {
	__typename?: "Tax";
	assetId?: Maybe<Scalars["ID"]>;
	fiatAmountAfterTax?: Maybe<CurrencyAmount>;
	fiatId: Scalars["ID"];
	isTaxServiceAvailable: Scalars["Boolean"];
	taxAmountAsset?: Maybe<CurrencyAmount>;
	taxAmountFiat: CurrencyAmount;
	taxResidency?: Maybe<Scalars["String"]>;
}

export interface TinDeclaration {
	__typename?: "TinDeclaration";
	missingCountryCodes?: Maybe<Array<Scalars["String"]>>;
}

/** TotalOrders */
export interface TotalOrdersFilter {
	fiatId?: InputMaybe<Scalars["ID"]>;
}

export interface TotalOrdersResult {
	__typename?: "TotalOrdersResult";
	fiats: Array<AmountWithFiat>;
}

/** TotalSellOrders */
export interface TotalSellOrdersFilter {
	assetWalletId?: InputMaybe<Scalars["ID"]>;
}

export interface TotalSellOrdersResult {
	__typename?: "TotalSellOrdersResult";
	amount: CurrencyAmount;
}

export interface Trade extends TradeWithId {
	__typename?: "Trade";
	amountAsset: CurrencyAmount;
	amountFiat: CurrencyAmount;
	assetId: Scalars["ID"];
	assetWallet: Wallet;
	executionTime: DateTime;
	fiatId: Scalars["ID"];
	fiatToEuroRate: CurrencyAmount;
	fiatWallet: Wallet;
	fiatWalletTransaction: FiatWalletTransaction;
	isFirstTrade?: Maybe<Scalars["Boolean"]>;
	isTaxable: Scalars["Boolean"];
	/** Set on Security trades such as Stocks and ETFs */
	premium?: Maybe<CurrencyAmount>;
	price: CurrencyAmount;
	serverTime: DateTime;
	status: TradeStatus;
	taxWithheld?: Maybe<Tax>;
	tradeId: Scalars["ID"];
	type: TradeType;
}

export enum TradeStatus {
	Canceled = "CANCELED",
	Finished = "FINISHED"
}

export enum TradeType {
	Buy = "BUY",
	Sell = "SELL"
}

export interface TradeWithId {
	tradeId: Scalars["ID"];
}

export interface TradingOperationInProgress {
	__typename?: "TradingOperationInProgress";
	operationId: Scalars["ID"];
	type: TradingOperationType;
}

/** TradingOperationsInProgress */
export interface TradingOperationInProgressResponse {
	__typename?: "TradingOperationInProgressResponse";
	affectedAssets?: Maybe<Array<Maybe<AssetTradingOperationsInProgress>>>;
}

export enum TradingOperationType {
	AcceptOffer = "ACCEPT_OFFER",
	BciTrade = "BCI_TRADE",
	Swap = "SWAP"
}

/** tradingSettings */
export interface TradingSettingsResponse {
	__typename?: "TradingSettingsResponse";
	marginTradingUnderlyingAssetId?: Maybe<Scalars["ID"]>;
}

/** Margin Trade */
export interface UnitDefinition {
	unitID: Scalars["ID"];
	unitType: UnitType;
}

export interface UnitDefinitionResponse {
	__typename?: "UnitDefinitionResponse";
	unitID: Scalars["ID"];
	unitType: UnitType;
}

export enum UnitType {
	Asset = "ASSET",
	Fiat = "FIAT"
}

export enum UpdateAction {
	Cancel = "CANCEL",
	Update = "UPDATE"
}

/** Margin Order Update */
export interface UpdateLimitMarginOrderRequest {
	action: UpdateAction;
	orderId: Scalars["ID"];
}

export type UpdateLimitMarginOrderResponse = MarginLimitOrderInProgressResponse | MarginLimitOrderSuccessResponse;

/** userSettings */
export interface UserSettingsResponse {
	__typename?: "UserSettingsResponse";
	advanceTradingTerms: Scalars["Boolean"];
	pepCheck: Scalars["Boolean"];
	tradingDisabled: Scalars["Boolean"];
	visionBonus?: Maybe<Scalars["Boolean"]>;
	visionBonusUserJourney: Scalars["String"];
}

/** UserSettingsUpdateRequest */
export interface UserSettingsUpdateRequest {
	visionBonus?: InputMaybe<Scalars["Boolean"]>;
}

export interface UserSettingsUpdateResponse {
	__typename?: "UserSettingsUpdateResponse";
	code: Scalars["Int"];
	visionBonus?: Maybe<Scalars["Boolean"]>;
}

/** Burns */
export interface VisionBurnData {
	__typename?: "VisionBurnData";
	nextBurnDate: DateTime;
	previousBurns: VisionBurnTransactionResponse;
	totalBurnedAmount: CurrencyAmount;
}

export interface VisionBurnTransaction {
	__typename?: "VisionBurnTransaction";
	assetAmount: CurrencyAmount;
	burnDate: DateTime;
	fiatAmount: CurrencyAmount;
}

export interface VisionBurnTransactionResponse {
	__typename?: "VisionBurnTransactionResponse";
	pageInfo: PaginationResponse;
	transactions: Array<VisionBurnTransaction>;
}

export interface VisionFeeDetail {
	__typename?: "VisionFeeDetail";
	bonus: Bonus;
	feeBefore: Scalars["String"];
	hasEnoughFunds: Scalars["Boolean"];
	visionAmount: Scalars["String"];
	visionRate: Scalars["String"];
}

export interface VisionTradingFeeBenefitResponse {
	__typename?: "VisionTradingFeeBenefitResponse";
	amount: CurrencyAmount;
}

/** VsnFeeTokenCollection */
export interface VsnFeeTokenCollection {
	__typename?: "VsnFeeTokenCollection";
	eligibleForVsn: Scalars["Boolean"];
	enabled: Scalars["Boolean"];
	feeDiscount: Scalars["String"];
	globalOptIn?: Maybe<Scalars["Boolean"]>;
	visionFeeDetail?: Maybe<VisionFeeDetail>;
}

export interface Wallet {
	__typename?: "Wallet";
	id: Scalars["ID"];
}

/** Wallet Balance */
export interface WalletBalanceInput {
	assetId: Scalars["ID"];
	walletId?: InputMaybe<Scalars["ID"]>;
}

export interface WalletBalanceResponse {
	__typename?: "WalletBalanceResponse";
	balance: Scalars["Decimal"];
}

export interface Web3MigrationEstimation {
	__typename?: "Web3MigrationEstimation";
	amount: CurrencyAmount;
	userJourney: Scalars["String"];
}

export interface Web3MigrationSignUpResponse {
	__typename?: "Web3MigrationSignUpResponse";
	code: Scalars["Int"];
	web3Migration: Web3MigrationStatus;
}

/** web3 */
export interface Web3MigrationStatus {
	__typename?: "Web3MigrationStatus";
	signedUp: Scalars["Boolean"];
}

/** createOrder */
export interface CreateOrderRequest {
	amount: CurrencyAmountInput;
	assetId: Scalars["ID"];
	assetWalletId?: InputMaybe<Scalars["ID"]>;
	fiatId: Scalars["ID"];
	price: CurrencyAmountInput;
	type: OrderType;
	visionBonus?: InputMaybe<Scalars["Boolean"]>;
}

/** UpdateOrder */
export interface UpdateOrderRequest {
	orderId: Scalars["ID"];
	status: OrderStatus;
}
